// extracted by mini-css-extract-plugin
export default {"departments_list":"Departments_departments_list__I9Poh","blur":"Departments_blur__6DAsb","departments":"Departments_departments__7V5Ej"};